import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import {
  InvoiceModel,
  InvoiceTypeEnum,
} from '../../../../../models/invoice.model';
import { AlertService } from '../../../../../services/alert.service';
import { BookingService } from '../../../../../services/booking.service';
import { InvoiceService } from '../../../../../services/invoice.service';
import { getStatus } from '../../../../../utils/invoice.utils';

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrl: './invoice-details.component.scss',
  standalone: false,
})
export class InvoiceDetailsComponent implements OnInit {
  public isLoading = true;
  public invoice: InvoiceModel;
  constructor(
    private activatedRoute: ActivatedRoute,
    private invoiceService: InvoiceService,
    private bookingService: BookingService,
    private alertService: AlertService,
    private location: Location
  ) {}

  public getStatus = getStatus;
  public invoiceType: InvoiceTypeEnum;
  public InvoiceTypeEnum = InvoiceTypeEnum;

  ngOnInit(): void {
    const invoiceId = this.activatedRoute.snapshot.params['invoiceId'];
    const type = this.activatedRoute.snapshot.params['type'];
    if (!invoiceId) {
      return;
    }
    if (type) {
      this.invoiceType = type;
    }
    this.getInvoice(+atob(invoiceId));
  }

  private getInvoice(invoiceId: number): void {
    this.invoiceService
      .getInvoiceById(invoiceId)
      .pipe(take(1))
      .subscribe({
        next: invoice => {
          this.isLoading = false;
          this.invoice = invoice;
        },
        error: error => {
          this.isLoading = false;
          console.error('Error fetching invoice', error);
        },
      });
  }

  public onDownloadInvoice(): void {
    this.invoiceService
      .downloadInvoice(this.invoice.id)
      .pipe(take(1))
      .subscribe({
        next: blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Rechnung-${this.invoice.invoiceNr}.pdf`;
          a.click();
        },
        error: error => {
          console.error('Error downloading invoice', error);
          this.alertService.showErrorAlert(
            'Die Rechnung konnte nicht heruntergeladen werden'
          );
        },
      });
  }

  public onApprovePayment(): void {
    if (this.invoice.type === InvoiceTypeEnum.BOOKING) {
      this.bookingService
        .confirmInvoicePayment(this.invoice.bookingId)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this.alertService.showSuccessAlert('Zahlung bestätigt');
            this.invoice.paymentStatus = 'paid';
          },
          error: error => {
            console.error('Error approving payment', error);
            this.alertService.showErrorAlert(
              'Die Zahlung konnte nicht bestätigt werden'
            );
          },
        });
    } else {
      this.invoiceService
        .confirmPayment(this.invoice.id)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this.alertService.showSuccessAlert('Zahlung bestätigt');
            this.invoice.paymentStatus = 'paid';
          },
          error: error => {
            console.error('Error approving payment', error);
            this.alertService.showErrorAlert(
              'Die Zahlung konnte nicht bestätigt werden'
            );
          },
        });
    }
  }

  public onGoBack(): void {
    this.location.back();
  }
}
